/*
    sidebar component should be a component usable for all main views
*/
import React from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import { _exchangeLabel } from "../../../../utils/Helper";
import SidebarFooter from "../../../components/SidebarFooter";

const FacilitySidebar = (props) => {
  const { facilities } = props;
  return (
    <aside id="inb-c-sidebar" className="filemanager-sidebar" style={{ float: "left" }}>
      <header className="inb-c-left-bar__title">
        <h1 className="inb-page-title">
          {t(_exchangeLabel("facilities"), null, "capital")} ({facilities.length})
        </h1>
      </header>

      {props.facilities.length === 0 && (
        <div>
          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-top">
              <div className="inb-c-loader--bg row"></div>
            </div>
          </div>

          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-center">
              <div className="inb-c-loader--bg row">
                <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                <div className="loader-mask vert-ph-1"></div>
                <div className="loader-mask vert-ph-2"></div>
                <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                <div className="loader-mask vert-ph-3"></div>
                <div className="loader-mask vert-ph-4"></div>
              </div>
            </div>
          </div>

          <div className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-center">
              <div className="inb-c-loader--bg row">
                <div className="loader-mask r-1 medium-offset-8 medium-4 column"></div>
                <div className="loader-mask vert-ph-1"></div>
                <div className="loader-mask vert-ph-2"></div>
                <div className="loader-mask r-2 medium-offset-9 medium-3 column"></div>
                <div className="loader-mask vert-ph-3"></div>
                <div className="loader-mask vert-ph-4"></div>
              </div>
            </div>
          </div>
        </div>
      )}

      <hr />

      <SidebarFooter
        rbac={rbac}
        label={t("add_${a}", { a: t(_exchangeLabel("facility")) })}
        id="inb-c-left-bar-add-facility"
        url="/facilities/add"
        icon="fi-page-add"
        specialPermission="write"
      />
    </aside>
  );
};

export default FacilitySidebar;
